/**
 * Container for an Location View component.
 */
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import { RootStoreState } from '../../root/index'
import { ScreenSection, Collection } from '../../api/types'

export interface OwnProps {
	collectionItemId?: number
	section: ScreenSection
}

export interface Props {
	item?: Collection
	section: ScreenSection
}

export interface Actions {}

const mapStateToProps = (state: RootStoreState, ownProps: OwnProps): Props => {
	const { collectionItemId } = ownProps

	const collection = collectionItemId ? state.collectionlist.collectionDetails.get(collectionItemId) : undefined

	const item: Collection | undefined = collection && collection.details ? collection.details : undefined

	return {
		item,
		...ownProps,
	}
}

const mapDispatchToProps = (_dispatch: Dispatch<AnyAction>): Actions => ({})

export default (Component: React.ComponentType<Props & Actions>) =>
	connect(mapStateToProps, mapDispatchToProps)(Component)
